import { callPromiseAssert } from "../../shared/util/callPromiseAssert";
import { viewJobNativeModule } from "./ViewJobNativeModule";

export function onDeepLinkLoadCompleted() {
  return callPromiseAssert(
    viewJobNativeModule()?.onDeepLinkLoadCompleted,
    "onDeepLinkLoadCompleted",
  );
}
